<template>
    <div class="video--button--grid--wrapper" ref="root">
        <h2 class="title">{{configuration.title}}</h2>
        <div class="video--grid">
            <div v-for="(item,key) in configuration.items" :key="key" class="button">
                <div v-if="item.videoId"  @click="videoPlay(item)" class="video--action">
                    <div class="button--icon">
                        <PlayIcon/>
                    </div>
                    <div class="video--text">
                        {{ item.title }}
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>

export default {
  name: "VideoButtonGrid",
  components: {
      PlayIcon: () => import(/* webpackPrefetch: true */ '../assets/svg/play-arrow.svg'),
  },
  props: {
      configuration: {
          type: Object,
          default: function () {
              return {}
          }
      }
  },
  data() {
    return {
        errors: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    resize() {},
    init() {

    },
    videoPlay(item) {
      this.$store.commit('activeVideo', item.videoId)
    },
  },
  computed: {

  }
};
</script>

<style scoped lang="scss">
.video--button--grid--wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: $base-spacing 5% $base-spacing 5%;
    box-sizing: border-box;
    font-family: 'Lato', 'Avenir', 'Helvetic', sans-serif !important;
}
</style>